import gsap from '../../js/gsap/gsap.min.js';
import { ScrollTrigger } from '../../js/gsap/ScrollTrigger.min.js';
import "../../js/theme/_lenis.js";
import "../../js/theme/_swipers.js";
 
gsap.registerPlugin(ScrollTrigger);
 